var _style, _path, _path2, _path3, _path4, _defs, _polygon, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BAD1C2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#929393;}\n\t.st3{clip-path:url(#SVGID_2_);fill:#325CA7;}\n\t.st4{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n\t.st5{fill:none;stroke:#929393;stroke-width:3;stroke-miterlimit:10;}\n\t.st6{fill:#F0C15E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.86,184.22c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C26.57,149.93,61.17,184.22,103.86,184.22"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.36,86.55l9.71,8.71h24.14C123.21,95.26,113,81.33,89.36,86.55z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.41,114.67l-9.21,7.22c0,0,12.94,5.72,24.64-2.24L79.41,114.67z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.53,105.96c0,0-21.4-14.68-51.76-12.94c-30.36,1.74-48.03,15.18-48.03,15.18s23.39,15.68,51.01,15.43 s46.53-11.94,46.53-11.94S164.27,109.2,160.53,105.96z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M160.53,105.96c0,0-21.4-14.68-51.76-12.94c-30.36,1.74-48.03,15.18-48.03,15.18s23.39,15.68,51.01,15.43 s46.53-11.94,46.53-11.94S164.27,109.2,160.53,105.96z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "56.76,108.7 171.98,108.7 166.5,97 120.22,87.55 70.2,90.29 59.75,100.24  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129.18,91.03c0,0,5.23,6.22,5.72,11.7c0.5,5.47,1.49,12.69,11.2,15.18c9.71,2.49,18.17,1.49,18.17,1.49 l3.24-11.94l-5.23-12.69l-23.89-2.49L129.18,91.03z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.74,108.2c0,0-3.48-9.46-13.94-18.91l4.48,19.66l-4.23,17.92C47.06,126.87,55.52,118.41,60.74,108.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M94.09,101.73c0,0-1.49,3.48-1.24,9.21"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.3,99.24c0,0-2.99,6.47-1.99,10.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M109.94,99.18c0,0-2.99,6.47-1.99,10.7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.65,99.43c0,0-2.99,6.47-1.99,10.7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M125.12,100.68c0,0-2.99,6.47-1.99,10.7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "117.07,115.17 117.07,108.7 136.23,108.7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrout);
export default __webpack_public_path__ + "static/media/Trout.2379e1dd59d3e6484bb4fd083790d214.svg";
export { ForwardRef as ReactComponent };